import { IApplicationState } from '../../types/redux';

export const selectIsOpenGallery = (state: IApplicationState): boolean => {
  return state.fullscreenGallery.isOpen;
};
